<ul class="filter-list">
    @for (filter of filters(); track filter.id; let last = $last) {
    <li
        class="br-primary__color--hover"
        [data-testing]="'filter-list-item-' + filter.id"
        [style.display]="filter.show === false ? 'none' : 'flex'"
        [class.br-link]="isActiveFilter(filter?.id)"
        [class.u-fw600]="isActiveFilter(filter?.id)"
        [class.group-divider]="last && showDivider()"
        (mousedown)="selectFilter(filter)"
    >
        @if (showCheckbox()) {
        <label class="checkbox-custom checkbox-custom-label-size u-mr0 u-mt2">
            <!--
                preventDefault stops the browser toggling the input itself. Selection is
                driven by (mousedown) on the row above, which fires first, so letting the
                native toggle run as well flips the box straight back and leaves it
                showing the opposite of isActiveFilter. aix-checkbox-list does the same
                thing via (click)="$event.defaultPrevented".
            -->
            <input
                type="checkbox"
                (click)="$event.preventDefault()"
                [checked]="isActiveFilter(filter?.id)"
            />
            <span class="checkbox-custom__indicator"></span>
        </label>
        }
        <span
            class="filter-list-label"
            [data-testing]="'label'"
            [class.br-primary__color]="isActiveFilter(filter?.id)"
        >
            {{ filter.label }} @if (filter.tooltip) {
            <span
                aixTooltip
                [aixTooltipContent]="filter.tooltip"
                [data-testing]="'filter-list-tooltip'"
                class="br-primary__color"
            ></span>
            }
        </span>
        @if (filter?.count || filter.count === 0) {
        <span class="aix-pill ph-mask"> {{ filter.count }} </span>
        }
    </li>
    }
</ul>
